import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import Header from '~/pages/Manager/Header';
import Footer from '~/pages/Manager/Footer';
import PF2MTable from '~/components/PF2MTable';

import {
  getChecklistTemplate,
  exportChecklist,
  importChecklist,
  getChecklist,
  resetFileUploadErrors,
} from '~/store/manager/actions';
import PF2MAlertDialog from '~/components/PF2MAlertDialog';

const ChecklistTab = ({
  classes,
  checklist,
  getChecklist: getAll,
  getChecklistTemplate: getTemplateAction,
  exportChecklist: exportAction,
  importChecklist: importAction,
}) => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showDialogImport, setShowDialogImport] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const fileUploadErrors = useSelector(state => state.manager.fileUploadErrors);

  useEffect(() => {
    async function fetchChecklist() {
      await getAll();
    }
    if (!dataLoaded) {
      fetchChecklist();
      setDataLoaded(true);
    }
  }, [dataLoaded, getAll]);

  useEffect(() => {
    if (fileUploadErrors && fileUploadErrors.length > 0) {
      const message = fileUploadErrors.map((error) => {
        const [rowCol, description] = error.split('-');
        const [row, col] = rowCol.split(';');
        return `${translate('validation:Row')} ${row} ${translate('validation:Col')} ${col} - ${translate(`validation:${description}`)}`;
      });
      setDialogMessage(message.join('\r\n'));
      setShowDialogImport(true);
    }
  }, [fileUploadErrors]);

  const columns = [
    {
      field: 'name',
      title: translate('common:Name').toUpperCase(),
    },
    {
      field: 'description',
      title: translate('common:Description').toUpperCase(),
      width: '100%',
      wrap: true,
    },
    { field: 'checked_name', title: translate('common:ObligatoryStop').toUpperCase() },
  ];

  return (
    <div className={classes.tabContainer}>
      <Header
        getTemplateAction={getTemplateAction}
        importAction={importAction}
        exportAction={exportAction}
      />
      <PF2MTable
        data={checklist}
        columns={columns}
      />
      <PF2MAlertDialog
        title={translate('validation:ImportErrors')}
        description={dialogMessage}
        open={showDialogImport}
        onConfirm={() => {
          setShowDialogImport(false);
          dispatch(resetFileUploadErrors());
        }}
        onClose={() => setShowDialogImport(false)}
        hasCancel={false}
      />
      <Footer />
    </div>
  );
};

ChecklistTab.propTypes = {
  classes: PropTypes.object.isRequired,
  checklist: PropTypes.array,
  getChecklist: PropTypes.func,
  getChecklistTemplate: PropTypes.func,
  exportChecklist: PropTypes.func,
  importChecklist: PropTypes.func,
};

ChecklistTab.defaultProps = {
  checklist: [],
  getChecklist: () => { },
  getChecklistTemplate: () => { },
  exportChecklist: () => { },
  importChecklist: () => { },
};

const mapStateToProps = state => ({
  checklist: state.manager.checklist,
});

const mapDispatchToProps = {
  getChecklist,
  getChecklistTemplate,
  exportChecklist,
  importChecklist,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChecklistTab));
